import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getCurrentMonthActivitiesAsync, getPeopleActivitiesDashboardAsync, getActivityByIdAsync, getPeopleMonthlyActivitiesForDashboardsAndCalendarAsync, getPeopleActivitiesByPersonIdAsync } from './peopleActivitiesThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const peopleActivitiesSlice = createSlice({
    name: 'peopleActivities',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCurrentMonthActivitiesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCurrentMonthActivitiesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.activities = action.payload;
        })
            .addCase(getCurrentMonthActivitiesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPeopleActivitiesDashboardAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPeopleActivitiesDashboardAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.groupedActivities = action.payload;
        })
            .addCase(getPeopleActivitiesDashboardAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getActivityByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getActivityByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.activity = action.payload;
        })
            .addCase(getActivityByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPeopleMonthlyActivitiesForDashboardsAndCalendarAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPeopleMonthlyActivitiesForDashboardsAndCalendarAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.monthlyActivitiesForDashboard = action.payload;
        })
            .addCase(getPeopleMonthlyActivitiesForDashboardsAndCalendarAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPeopleActivitiesByPersonIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPeopleActivitiesByPersonIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.peopleActivitiesByPersonId = action.payload;
        })
            .addCase(getPeopleActivitiesByPersonIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default peopleActivitiesSlice.reducer;
